function lerp(v0, v1, t) {
    return v0*(1-t)+v1*t
}
module.exports = lerp


//////////////////
// WEBPACK FOOTER
// ./node_modules/lerp/index.js
// module id = 287
// module chunks = 0